import { FilterContainer } from './SwitchFilter.styles';
import { FormSwitch, Typography } from '../../../../../base';
import { Control, FieldValues } from 'react-hook-form';

interface Props {
    name: string;
    control: Control<FieldValues>;
    title: string;
}

const SwitchFilter = ({ title, name, control }: Props) => {
    return (
        <FilterContainer>
            <Typography variant="subtitle1" gutterBottom>
                {title}
            </Typography>
            <FormSwitch name={name} control={control} />
        </FilterContainer>
    );
};

export default SwitchFilter;
